export const environment = {
  production: false,
  isDeployChangesEnabled: true,
  apiUrl: 'https://api.dev.portal.joynd.io/api',
  baseUrl: 'https://api.dev.portal.joynd.io'
};
